import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
type PageIntroProps = {
  breadcrumb: string;
  h1: string;
  lead: string;
  meta?: string;
};
export function PageIntro({
  breadcrumb,
  h1,
  lead,
  meta
}: PageIntroProps) {
  return <section className="border-b border-line bg-white" data-id="element-109" data-mp="2z4kqzz6x8q0x">
      <div className="mx-auto max-w-shell px-6 pb-14 pt-10 md:pb-20 md:pt-14" data-id="element-110" data-mp="338sg3xhak7zo">
        <nav aria-label="Kruimelpad" className="flex items-center gap-1 text-[13px] text-ink-mute" data-id="element-111" data-mp="3qxbo0bwfiir8">
          <Link to="/" className="transition-colors hover:text-accent" data-id="element-112" data-mp="3vwwk8ek7sd09">
            Home
          </Link>
          <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-113" data-mp="3hvu0i8gozesi" />
          <span className="text-ink" data-id="element-114" data-mp="3mvgnvaq8ibf1">{breadcrumb}</span>
        </nav>
        <div className="mt-8 grid gap-8 lg:grid-cols-[1.15fr_1fr] lg:gap-16" data-id="element-115" data-mp="3mxt33g4ly7oe">
          <h1 className="font-display text-4xl font-700 leading-[1.04] tracking-tightest text-ink md:text-[56px]" data-id="element-116" data-mp="26gf2d1cqygvt">
            {h1}
          </h1>
          <div data-id="element-117" data-mp="18umbwmsenqui">
            <p className="text-[18px] leading-relaxed text-ink-soft" data-id="element-118" data-mp="18u2s10j72sdu">{lead}</p>
            {meta && <p className="mt-5 border-l-2 border-accent pl-4 text-[15px] text-ink-mute" data-id="element-119" data-mp="13waxrzv2uu6h">{meta}</p>}
          </div>
        </div>
      </div>
    </section>;
}